<script>
    export let sentence;
</script>

<p class="m-0 flex items-center flex-1">{sentence}</p>